module.exports = __webpack_public_path__ + "static/media/size4.abe2565a.svg";